import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const SITE_URL = "https://planfirstnsw.com.au";

const DEFAULT_TITLE = "PLAN FIRST NSW — Before You Buy. Before You Build. PLAN FIRST.";
const DEFAULT_DESC =
  "Independent NSW planning education platform. Plain-English guides, interactive toolkits and AI-assisted roadmaps that help property owners, buyers, renovators and rural landowners understand planning processes across New South Wales.";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const Seo = ({ title, description, noindex = false, canonicalPath }) => {
  const location = useLocation();
  useEffect(() => {
    const t = title ? `${title} | PLAN FIRST NSW` : DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    const path = canonicalPath ?? location.pathname;
    const url = `${SITE_URL}${path === "/" ? "/" : path.replace(/\/$/, "")}`;
    document.title = t;
    setMeta("name", "description", d);
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", t);
    setMeta("name", "twitter:description", d);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setCanonical(url);
  }, [title, description, noindex, canonicalPath, location.pathname]);
  return null;
};

export default Seo;
